import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { siQuoteUrls } from '../../../environments/environment';
import { BaseHttpService, StreamEvent } from "./base-http.service";
import {
    CreateOpportunityRequest,
    CreateOpportunityResponse,
    CustomerSearchRequest,
    CustomerSearchResponse,
    FFDropDownCollectionResponse,
    LinkUnlinkOpportunityRequest,
    LinkUnlinkOpportunityResponse,
    OpportunityModel,
    OpportunityRequest,
    OpportunityVerificationResponse,
    SearchOpportunityRequest,
    VerifyOpportunityRequest
} from "../../models/dtos";
import { HttpContext } from "@angular/common/http";
import { withBackgroundRequest, withSilentBackgroundRequest } from "../../core/errors/http-context-tokens";

/**
 * Progress event emitted while an opportunity is created on the server.
 * 'status' carries a step description and 'result' the final response.
 */
export type CreateOpportunityEvent = StreamEvent<CreateOpportunityResponse>;

/**
 * Progress event emitted while an opportunity is linked to / unlinked from an estimate.
 */
export type LinkUnlinkOpportunityEvent = StreamEvent<LinkUnlinkOpportunityResponse>;

@Injectable({
  providedIn: 'root'
})
export class CRMApiService {
  
  constructor(private readonly baseHttp: BaseHttpService) { }

  searchCustomers(requestBody: CustomerSearchRequest): Observable<CustomerSearchResponse> {
    return this.baseHttp.post<CustomerSearchResponse>(`${siQuoteUrls.crm}/SearchCustomer`, requestBody);
  }

  getUSInfoDDLists(): Observable<FFDropDownCollectionResponse>{
    return this.baseHttp.get<FFDropDownCollectionResponse>(`${siQuoteUrls.crm}/GetFederalRefundedDDCollection`);
  }

  getOpportunity(request: OpportunityRequest): Observable<OpportunityModel> {
    return this.baseHttp.post<OpportunityModel>(`${siQuoteUrls.crm}/GetOpportunity`, request);
  }

  searchOpportunities(requestBody: SearchOpportunityRequest): Observable<OpportunityModel[]> {
    return this.baseHttp.post<OpportunityModel[]>(`${siQuoteUrls.crm}/SearchOpportunity`, requestBody);
  }

  verifyOpportunityCanLink(request: VerifyOpportunityRequest): Observable<OpportunityVerificationResponse> {
    return this.baseHttp.post<OpportunityVerificationResponse>(`${siQuoteUrls.crm}/VerifyOpportunityCanLink`, request);
  }

  linkOpportunity(request: LinkUnlinkOpportunityRequest): Observable<LinkUnlinkOpportunityEvent> {
    const context: HttpContext = withBackgroundRequest();
    return this.baseHttp.postTypedStream<LinkUnlinkOpportunityResponse>(`${siQuoteUrls.crm}/LinkOpportunity`, request, { context });
  }

  unlinkOpportunity(request: LinkUnlinkOpportunityRequest): Observable<LinkUnlinkOpportunityEvent> {
    const context: HttpContext = withBackgroundRequest();
    return this.baseHttp.postTypedStream<LinkUnlinkOpportunityResponse>(`${siQuoteUrls.crm}/UnLinkOpportunity`, request, { context });
  }

  createOpportunity(request: CreateOpportunityRequest): Observable<CreateOpportunityEvent> {
    const context: HttpContext = withSilentBackgroundRequest();
    return this.baseHttp.postTypedStream<CreateOpportunityResponse>(`${siQuoteUrls.crm}/CreateOpportunity`, request, { context });
  }
}